import { render, staticRenderFns } from "./NotificationAlert.vue?vue&type=template&id=2e7f4f5f&scoped=true&"
import script from "./NotificationAlert.vue?vue&type=script&lang=js&"
export * from "./NotificationAlert.vue?vue&type=script&lang=js&"
import style0 from "./NotificationAlert.vue?vue&type=style&index=0&id=2e7f4f5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7f4f5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e7f4f5f')) {
      api.createRecord('2e7f4f5f', component.options)
    } else {
      api.reload('2e7f4f5f', component.options)
    }
    module.hot.accept("./NotificationAlert.vue?vue&type=template&id=2e7f4f5f&scoped=true&", function () {
      api.rerender('2e7f4f5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/NotificationAlert.vue"
export default component.exports